function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, forwardRef } from 'react';
import { DateTime } from 'luxon';
import { useRifm } from 'rifm';
import TextField from '../text-field';
const parseDigits = value => (value.match(/\d+/g) || []).join('');
const formatDate = value => {
  const digits = parseDigits(value);
  const chars = digits.split('');
  return chars.reduce((r, v, index) => index === 2 || index === 4 ? `${r}/${v}` : `${r}${v}`, '').substr(0, 10);
};
const addMask = string => {
  const digits = parseDigits(string);
  const months = digits.slice(0, 2).padEnd(2, 'M');
  const days = digits.slice(2, 4).padEnd(2, 'D');
  const years = digits.slice(4, 8).padEnd(4, 'Y');
  return `${months}/${days}/${years}`;
};
const DATE_FORMAT = 'MM/dd/yyyy';
export const KeyboardDatePicker = /*#__PURE__*/forwardRef(({
  value: defaultValue,
  onChange: defaultOnChange,
  minDate,
  label = 'Date',
  placeholder = 'MM/DD/YYYY',
  id,
  ...props
}, ref) => {
  const defaultDate = defaultValue ? DateTime.fromJSDate(defaultValue) : null;
  const [value, setValue] = useState(defaultDate && defaultDate.isValid ? defaultDate.toFormat(DATE_FORMAT) : '');
  const onChange = value => {
    setValue(value);
    if (defaultOnChange) {
      defaultOnChange(DateTime.fromFormat(value, DATE_FORMAT).toJSDate());
    }
  };
  const rifm = useRifm({
    value,
    onChange,
    format: formatDate,
    replace: addMask
  });
  return /*#__PURE__*/React.createElement(TextField, _extends({
    type: "text",
    ref: ref,
    nativeOnChange: rifm.onChange,
    value: rifm.value,
    placeholder,
    label,
    minDate,
    id
  }, props));
});
KeyboardDatePicker.displayName = 'KeyboardDatePicker';
export default KeyboardDatePicker;
//# sourceMappingURL=index.js.map